<script setup lang="ts">
import type { GlobalDeviceConfiguration } from "~/modules/globalDeviceConfiguration/models/GlobalDeviceConfiguration.interface";

defineProps<{
  globalDeviceConfigurations?: GlobalDeviceConfiguration[];
}>();

const { t } = useI18n();
</script>

<template>
  <div
    v-if="globalDeviceConfigurations && globalDeviceConfigurations.length > 0"
  >
    <div class="mb-6 grid gap-y-2">
      <global-device-configuration-list-information
        :title="
          t(
            'dtwins.globalConfiguration.automaticRenewalDelay.information.title',
          )
        "
        :body="
          t('dtwins.globalConfiguration.automaticRenewalDelay.information.body')
        "
      />
      <global-device-configuration-list-information
        :title="
          t('dtwins.globalConfiguration.pollingFrequency.information.title')
        "
        :body="
          t('dtwins.globalConfiguration.pollingFrequency.information.body')
        "
      />
    </div>

    <div class="flex flex-wrap -mt-3 -mr-4 -mb-3 -ml-4">
      <div
        v-for="globalDeviceConfiguration of globalDeviceConfigurations"
        :key="globalDeviceConfiguration.uid"
        class="w-1/3 min-w-96"
      >
        <div class="pt-3 pr-4 pb-3 pl-4">
          <global-device-configuration-list-item
            :global-device-configuration="globalDeviceConfiguration"
          />
        </div>
      </div>
    </div>
  </div>
  <no-data v-else />
</template>
